export default __webpack_public_path__ + "static/media/Roughbengal-lang.2dda521b.png";